/* GASSISA
=========================================================================================
* Descripcion: Version portatil del formulario de parametros de caja.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmParametrosCaja from "../../configuracion/FrmParametrosCaja.jsx";
import SizeSoftXFrmPortatil from "../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmParametrosCajaPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmParametrosCaja">
      <FrmParametrosCaja />
    </SizeSoftXFrmPortatil>
  );
}
